import LegalPage from "@/pages/legal/LegalPage";

const sections = [
  {
    heading: "1. Agreement",
    body: [
      "These Terms of Service govern your use of the Fortuna Strive website operated by Fortunastrive Services Private Limited. By accessing or using this website, you agree to these terms.",
    ],
  },
  {
    heading: "2. Services",
    body: [
      "Fortuna Strive provides consulting and systems implementation services, including business strategy, web design and development, marketing automation, AI and systems, brand and messaging, and growth advisory.",
      "The content on this website is provided for general information. It does not constitute a guarantee of any specific outcome, result, revenue, funding, or lead volume.",
    ],
  },
  {
    heading: "3. Enquiries & Engagements",
    body: [
      "Submitting an enquiry does not create a contract. Any engagement is subject to a separate written agreement setting out scope, fees, and deliverables.",
    ],
  },
  {
    heading: "4. Intellectual Property",
    body: [
      "All content, branding, and materials on this website are the property of Fortunastrive Services Private Limited unless otherwise stated, and may not be reproduced without permission.",
    ],
  },
  {
    heading: "5. Acceptable Use",
    body: ["You agree not to misuse this website, attempt to disrupt its operation, or use it for any unlawful purpose."],
  },
  {
    heading: "6. Limitation of Liability",
    body: [
      "To the maximum extent permitted by law, Fortuna Strive is not liable for any indirect or consequential loss arising from the use of this website or reliance on its content.",
    ],
  },
  {
    heading: "7. Governing Law",
    body: [
      "These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of the courts of West Bengal, India.",
    ],
  },
  {
    heading: "8. Changes",
    body: ["We may update these terms from time to time. Continued use of the website constitutes acceptance of the revised terms."],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      label="Legal"
      title="Terms of Service"
      updated="January 2026"
      intro="The terms that govern your use of the Fortuna Strive website."
      sections={sections}
    />
  );
}
